import React, { useState } from 'react';
import { useLocation } from 'react-router';

import BasicLayout from 'components/BasicLayout';
import EmptyList from 'components/EmptyList';
import { Desktop, Mobile } from 'components/Responsive';
import TripCard, { ShimmerTripCard } from 'components/TripCard';
import TripListContainer from 'containers/TripList';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelForCustomerSupport } from 'models/customerSupport';

import { mapCustomerSupportTravel } from '../../utils/mapper';
import Contact from '../Contact';
import { SectionTitle, HeaderWithLink, AllTripsLink, TripCarousel, TripCardWrapper } from './styles';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

type TripListProps = {
  travels: TravelForCustomerSupport[];
  totalCount: number;
  detailsOpen: boolean;
  onToggle: (status: boolean) => void;
};

const TripList = ({ travels, totalCount, detailsOpen, onToggle }: TripListProps) => {
  const { t } = useStoreTranslation();

  return travels.length > 0 ? (
    <TripCarousel options={{ gap: 16, arrows: false }}>
      {[...Array(totalCount).keys()].map((index) => {
        const travel = travels[index];

        return (
          <TripCardWrapper key={index}>
            {travel ? (
              <TripCard travel={mapCustomerSupportTravel(travel)} onToggle={onToggle} detailsOpen={detailsOpen}>
                {/* <HelpLink to={`/customerSupport/trip/${travel.travelId}`}>{t('customerSupport.mobileTitle')}</HelpLink> */}
              </TripCard>
            ) : (
              <ShimmerTripCard />
            )}
          </TripCardWrapper>
        );
      })}
    </TripCarousel>
  ) : (
    <EmptyList
      transparent
      compact
      title={t('customerSupport.home.tripList.empty.title')}
      description={t('customerSupport.home.tripList.empty.description')}
      paddingMessage={48}
      image="/corporate/images/receipt-list-43-colored-48.svg"
    />
  );
};

const Home = () => {
  const { t } = useStoreTranslation();
  const location = useLocation<{ channelsOpen?: boolean }>();
  const [detailsOpen, setDetailsOpen] = useState(false);

  const get3CXWidget = () => {
    const useZendeskChat = companyConfiguration?.script3CX?.trim()
                          ? companyConfiguration.script3CX
                          : undefined;


    const existing = document.getElementById('ze-snippet');

    if (useZendeskChat === undefined) {
      return `<call-us-selector phonesystem-url="https://cellvozirld.3cx.co" minimized="false" party="${companyConfiguration?.script3CX ?? 'LiveChat955047'}" style="position:fixed;font-size:16px;line-height:17px;z-index: 99999;--call-us-main-accent-color:${companyConfiguration?.primaryBackgroundColor};--call-us-main-background-color:#FFFFFF;--call-us-plate-background-color:${companyConfiguration?.primaryBackgroundColor};--call-us-plate-font-color:#E6E6E6;--call-us-main-font-color:#292929;--call-us-agent-bubble-color:#29292910;right: 50%; bottom: 20px;"></call-us-selector>`;
    }
    else {
        
      if (!existing) {
        const scriptKey = companyConfiguration?.script3CX?.trim()
                          ? companyConfiguration.script3CX
                          : 'ff58569d-f6bd-483f-8462-ecd256a30d7a';

        const script = document.createElement('script');
        script.id = 'ze-snippet';
        script.src = `https://static.zdassets.com/ekr/snippet.js?key=${scriptKey}`;
        document.body.appendChild(script);
      }
    }
  };

  const getWhatsAppWidget = () =>
    `<a href="https://api.whatsapp.com/send?phone=${companyConfiguration?.menuView?.useWhatsappSupport}&text=${companyConfiguration?.menuView?.useWhatsappSupportMessage}" target="_blank" style="position:fixed;font-size:16px;line-height:17px;z-index: 99999;;right: 5%; bottom: 32px;"><img src="/corporate/images/whatsapp-active.svg" alt="WhatsApp" style="width: 50px; height: 50px;"/></a>`;

  const renderChat = () =>
    companyConfiguration?.menuView?.useWhatsappSupport === '' ||
    companyConfiguration?.menuView?.useWhatsappSupport === null ||
    companyConfiguration?.menuView?.useWhatsappSupport === undefined
      ? get3CXWidget()
      : getWhatsAppWidget();

  const companyConfiguration = useSelector((state: RootState) => state.companyConfiguration.configuration);

  return (
    <>
      <Mobile>
        <BasicLayout withFloatingButton backPath="/corporate/dashboard" title={t('customerSupport.title')}>
          <HeaderWithLink>
            <SectionTitle>{t('customerSupport.tripSupportTitle')}</SectionTitle>
            <AllTripsLink to="/corporate/customerSupport/allTrips">{t('customerSupport.viewAllTrips')}</AllTripsLink>
          </HeaderWithLink>

          <TripListContainer
            render={(loading, { travels, totalCount }) =>
              loading ? (
                <TripCardWrapper>
                  <ShimmerTripCard />
                </TripCardWrapper>
              ) : (
                <TripList
                  travels={travels}
                  totalCount={totalCount}
                  detailsOpen={detailsOpen}
                  onToggle={(status) => setDetailsOpen(status)}
                />
              )
            }
          />

          {/* <SectionTitle>{t('customerSupport.faq.title')}</SectionTitle>
          <MenuList>
            {Object.keys(faqSchema).map((section) => (
              <MenuListItem
                key={section}
                to={`/corporate/customerSupport/faq/${section}`}
                label={t(`faq.${section}.title`)}
              ></MenuListItem>
            ))}
          </MenuList> */}

          { <div dangerouslySetInnerHTML={{ __html: renderChat() }}></div>}
          
          {/* <ChannelsFloatingMenu defaultOpen={location.state?.channelsOpen} /> */}
        </BasicLayout>
      </Mobile>
      <Desktop>
        <Contact />
      </Desktop>
    </>
  );
};

export default Home;
